// Maps a saved quote document back into Quote Builder state for re-editing.

const FORM_KEYS = [
  "customer_name", "quote_ref", "sales_rep", "customer_type", "shipping_mode",
  "fedex_service_type", "declared_value", "origin_zip", "destination_zip",
  "origin_city", "origin_state", "dest_city", "dest_state",
  "pickup_location_type", "delivery_location_type", "pickup_date", "notes",
  "customer_address_id", "dest_company", "dest_address1", "dest_contact_name",
  "dest_contact_phone", "dest_contact_email", "origin_company", "origin_address1",
  "origin_contact_name", "origin_contact_phone", "status",
];

export function quoteToForm(q) {
  const out = {};
  for (const k of FORM_KEYS) if (q[k] !== undefined && q[k] !== null) out[k] = q[k];
  out.accessorials = { ...(q.accessorials || {}) };
  if (q.product_id) out.product_id = q.product_id;
  if (q.quantity != null) out.quantity = q.quantity;
  return out;
}

// Resolved/stored line items carry the TOTAL weight + resolved class. Manual items reload
// with the "Total Wgt" toggle ON; catalog items reload by product + original quantity so the
// stack engine deterministically reproduces them.
export function quoteToItems(q) {
  const rand = () => Math.random().toString(36).slice(2);
  return (q.line_items || []).map((li) => {
    const isCatalog = li.mode === "catalog" && !!li.product_id;
    const desc =
      li.description && li.description !== "Manual item" && li.description !== li.product_name
        ? li.description
        : "";
    return {
      _key: rand(),
      mode: isCatalog ? "catalog" : "manual",
      product_id: li.product_id || "",
      quantity: li.pieces || 1,
      units: li.units || 1,
      handling_unit_type: li.handling_unit_type || "Pallet",
      pieces: li.pieces || 1,
      weight: isCatalog ? "" : (li.weight ?? ""),
      weight_is_total: !isCatalog,
      length: isCatalog ? "" : (li.length ?? ""),
      width: isCatalog ? "" : (li.width ?? ""),
      height: isCatalog ? "" : (li.height ?? ""),
      freight_class: isCatalog ? "" : (li.freight_class || ""),
      nmfc: li.nmfc || "",
      description: desc,
      stackable: !!li.stackable,
      hazmat: !!li.hazmat,
      used: !!li.used,
      machinery: !!li.machinery,
    };
  });
}

// Rebuilds the workspace rate-result object from a saved quote (no re-rating needed).
export function quoteToResult(q) {
  const rates = q.rates || [];
  const recCode = q.recommended_carrier_code || q.selected_carrier_code;
  return {
    rates,
    stack_result: q.stack_result,
    calculated_class: q.calculated_class,
    fak: q.fak,
    warnings: q.warnings || [],
    diagnostics: q.diagnostics,
    confidence_score: q.confidence_score,
    financial: q.financial,
    recommended_carrier_code: recCode,
    recommended: rates.find((r) => r.carrier_code === recCode) || null,
    totals: q.totals,
    line_items: q.line_items || [],
    is_multi: !!q.is_multi,
  };
}

export function isMultiQuote(q) {
  return !!(q && (q.is_multi || (q.line_items && q.line_items.length > 0)));
}

export function isQuoteLocked(q) {
  return !!(q && (q.status === "booked" || q.bol_pro_number));
}
